import * as userAction from "store/actions/team.action";
const user = (
  state = {
    status: null,
    teamloading: false,
    error: null,
    teamdetail: null,
    seoData: null,
  },
  action,
) => {
  switch (action.type) {
    case userAction.TEAM_FAR_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        teamloading: true,
      });
    case userAction.TEAM_FAR_SUCCESS:
      return Object.assign({}, state, {
        teamdetail: action.teamdetail.teams[0],
        seoData: { metadata: action?.teamdetail?.metadata },
        status: action.status,
        teamloading: false,
      });

    case userAction.TEAM_FAR_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    default:
      return state;
  }
};
export default user;
